import { type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: "/booked-sessions",
    name: ROUTE_NAME.BOOKED_SESSIONS,
    meta: { requiresPayments: true },
    component: () => import("./views/BookedSessionsView.vue"),
  },
];
